import { DefaultTheme, type Theme } from "expo-router/react-navigation"
import { DynamicColorIOS, Platform } from 'react-native'

/** The app's single theme color. Keep in sync with the withAccentColor plugin options in app.config.js. */
export const BRAND_COLOR = { light: '#155DFC', dark: '#2B7FFF' } as const

/** Follows light/dark on iOS without a re-render, for native props such as tab and bar item tint colors. */
export const BRAND_COLOR_IOS = Platform.OS === 'ios' ? DynamicColorIOS(BRAND_COLOR) : BRAND_COLOR.light

export const NavigationLightTheme: Theme = {
  ...DefaultTheme,
  dark: false,
  colors: {
    primary: BRAND_COLOR.light,
    background: 'rgb(255, 255, 255)',
    card: 'rgb(255, 255, 255)',
    text: 'rgb(23, 23, 23)',
    border: 'rgb(229, 231, 235)',
    notification: 'rgb(255, 59, 48)',
  },
}

export const NavigationDarkTheme: Theme = {
  ...DefaultTheme,
  dark: true,
  colors: {
    primary: BRAND_COLOR.dark,
    background: 'rgb(18, 18, 18)',
    card: 'rgb(18, 18, 18)',
    text: 'rgb(219, 219, 220)',
    border: 'rgb(229, 231, 235)',
    notification: 'rgb(255, 59, 48)',
  },
}

/** Android SearchView can keep stale text/hint colors after light/dark switch; tie colors to navigation theme. */
export function androidHeaderSearchBarThemeProps(theme: Theme) {
  if (Platform.OS !== 'android') {
    return {}
  }
  return {
    textColor: theme.colors.text,
    headerIconColor: theme.colors.text,
  }
}
